import toNumber from './toNumber.js';

var MAX_VALUE = 1.7976931348623157e308;
function toFinite(value) {
    if (!value) {
        return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === Infinity || value === -Infinity) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_VALUE;
    }
    return value === value ? value : 0;
}

export { toFinite as default };
